export const isPreprod = import.meta.env.VITE_APP_STAGE === "preprod";
export const isProd = import.meta.env.VITE_APP_STAGE === "production";
export const isMaintenance = import.meta.env.VITE_APP_MAINTENANCE === "true";
